<template>
  <!-- Footer -->
  <footer class="text-md-left text-center p-4 bg-dark text-light" id="contato">
    <div class="container">
      <div class="row">
        <div class="my-3 col-md-9">
          <img src="@/assets/imagens/footer_logo_novo.png" width="100%" alt="Logo Rodape">
        </div>
        <div class="my-3 col-md-3">
          <h6>Redes Sociais</h6>
          <a href="https://www.facebook.com/PrefeituraMunicipalToledo" target="blank">
            <font-awesome-icon :icon="['fab', 'facebook-f']" class="text-muted m-2" />
            </a>
          <a href="https://www.instagram.com/prefeituradetoledo/" target="blank">
            <font-awesome-icon :icon="['fab', 'instagram']" class="text-muted m-2"/>
          </a>
          <a href="https://twitter.com/PrefsdeToledo" target="blank">
            <font-awesome-icon :icon="['fab', 'twitter']" class="text-muted m-2"/>
          </a>
          <!--<a href="https://plus.google.com" target="blank"><i
                  class="fa fa-3x fa-google-plus-official text-muted m-2"></i></a>-->
          <!--<a href="https://pinterest.com" target="blank"><i
                  class="fa fa-3x text-muted fa-pinterest-p m-2"></i></a>-->
          <!--<a href="https://www.youtube.com" target="blank"><i class="fa fa-3x text-muted fa-youtube-play m-2"></i></a>-->
        </div>
      </div>
      <div class="row text-center">
        <div class="col-md-12">
          <p class="text-muted">© Copyright 2020-2021 Prefeitura de Toledo - Todos os direitos reservados.</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Bloco99Footer"
}
</script>

<style scoped>

</style>